module.exports = __webpack_public_path__ + "static/media/29ADMSPC39.f768876b.jpg";